import { createAction, props } from "@ngrx/store";
import { Priority, RiskLevel, Source } from "src/app/data/models/sources/source";

export const getPriorities = createAction('Get Priorities');
export const prioritiesRetrieved = createAction('Priorities Retrieved', props<{ priority: Priority[] }>());

export const getRiskLevel = createAction('Get Risk Level');
export const riskLevelRetrieved = createAction('Risk Level Retrieved', props<{ riskLevel: RiskLevel[] }>());

export const getSources = createAction('Get Sources');
export const sourcesRetrieved = createAction('Sources Retrieved', props<{ source: Source[] }>());